export enum AccionesSancionesEnum {
    editar          = 1,
    innactivar      = 2,
    eliminar        = 3,
    asignar         = 4,
}
export enum EstadosSancionesEnum{
    Activo    = 1,
    Innactivo = 2,
    Eliminado = 3
}

